<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open" data-cy="modal_pdpa_modal">
            <div class="modal-content" data-cy="container_pdpa_modal_content">
                <div class="bg-white w-full rounded-xl p-3" data-cy="container_pdpa_modal_body">
                    <PdpaContent
                        :type="type"
                        :localeCode="localeCode"
                        :v-model:version="version"
                        @onError="onError($event)"
                        data-cy="component_pdpa_modal_pdpa_content" />

                    <div class="grid grid-cols-5 gap-5">
                        <SecondaryButton
                            class="col-span-2"
                            btnId="cancel_btn"
                            :btnMsg="btnCancel"
                            @onClick="onCancel()"
                            data-cy="component_pdpa_modal_btn_cancel" />
                        <PrimaryButton
                            class="col-span-3"
                            btnId="confirm_btn"
                            :btnMsg="btnOk"
                            @onClick="onOk()"
                            data-cy="component_pdpa_modal_btn_confirm" />
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open" data-cy="container_pdpa_modal_backdrop"></div>
    </transition>
</template>
<script>
// mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
// component
import PdpaContent from '@/components/Authen/Pdpa/PdpaContent.vue';
import PrimaryButton from '@/components/Button/PrimaryButton.vue';
import SecondaryButton from '@/components/Button/SecondaryButton.vue';
export default {
    name: 'PdpaModal',
    mixins: [LocaleMixin],
    components: {
        PdpaContent,
        PrimaryButton,
        SecondaryButton
    },
    props: {
        controller: { type: Object }
    },
    data: function () {
        return {
            open: false,

            title: '',
            type: '',
            version: '',
            busModal: null
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        //#region event
        onOk: function () {
            this.hide();
            this.sendCallbackOk(this.version);
        },
        onCancel: function () {
            this.hide();
            this.controller.sendCallbackCancel();
        },  
        onError: function (err) {
            this.hide();
            this.controller.alertModal
                .clearModal()
                .setMsg(err.message)
                .show();
        },
        //#endregion event
        show: function (config) {
            this.title = config.title;
            this.type = config.type || 'terms';

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;
        }
    }
}
</script>